import { render, staticRenderFns } from "./DistributionDetailField.vue?vue&type=template&id=2a1ae3dc&scoped=true&"
import script from "./DistributionDetailField.vue?vue&type=script&lang=js&"
export * from "./DistributionDetailField.vue?vue&type=script&lang=js&"
import style0 from "./DistributionDetailField.vue?vue&type=style&index=0&id=2a1ae3dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1ae3dc",
  null
  
)

export default component.exports